import { ConsentSignatureResultModel, FileResultModel, QuestionResultModel, ResultModel } from "../types/SurveyResult";

function questionResultHasAnswer(result: ResultModel): boolean {
    const questionResult = result as QuestionResultModel;
    return Array.isArray(questionResult.Answers) && questionResult.Answers.some((answer: string) => !!answer);
}

function fileResultHasAnswer(result: ResultModel): boolean {
    const fileResult = result as FileResultModel;
    // File is the not-yet-uploaded local pick; FileName is what survives a save.
    return !!fileResult.FileName || !!fileResult.File;
}

function signatureResultHasAnswer(result: ResultModel): boolean {
    const consentSignatureResult = result as ConsentSignatureResultModel;
    return !!consentSignatureResult.Signature &&
        (!!consentSignatureResult.Signature.FamilyName ||
            !!consentSignatureResult.Signature.GivenName ||
            !!consentSignatureResult.Signature.HandwrittenSignatureBase64);
}

export function hasAnswer(result: ResultModel | undefined): boolean {
    if (!result) return false;

    // Dispatch on Type rather than on which keys are present: a result can carry fields
    // belonging to more than one shape (an empty Answers alongside a Signature), and a
    // key-presence check would then answer for the wrong field.
    switch (result.Type) {
        case "QuestionResult":
            return questionResultHasAnswer(result);
        case "FileResult":
            return fileResultHasAnswer(result);
        case "ConsentSignatureResult":
            return signatureResultHasAnswer(result);
        case "WebViewStepResult":
            // A web view step reports completion rather than an answer.
            return false;
    }

    // Every result this app builds carries a Type, but a result restored from a survey in
    // progress originates on the server. Fall back to the shape it looks like rather than
    // reporting no answer, which would strand the participant on a question they answered.
    if ("Answers" in result) return questionResultHasAnswer(result);
    if ("FileName" in result) return fileResultHasAnswer(result);
    if ("Signature" in result) return signatureResultHasAnswer(result);
    return false;
}
